/**
 * Init this module.
 */
const init = () => {
	const videos = $('.media-grid video')

	videos.each((index, vid) => {
		const video = $(vid)
		const button = video.siblings('button')

		button.on('click', () => {
			const current = video.get(0)
			button.toggleClass('pause')
			if (current.paused) {
				current.play()
			} else {
				current.pause()
			}
		})
	})

	let next = $('.module-media').next()
	let prev = $('.module-media').prev()

	$(next).addClass('adjacent-below')
	$(prev).addClass('adjacent-above')

	if (!$(next).next().hasClass('module-media')) {
		$(next).addClass('nothing-below')
	}

	if (!$(prev).prev().hasClass('module-media')) {
		$(prev).addClass('nothing-above')
	}
}

export default init
